import { notification } from "antd";
import axios from "axios";
import { createStore } from "redux";
import { setErrorResponseStatus, setRedirect, setURL } from "../actions";
import throwError from "../components/helpers/helpers";
import i18n from "../i18n";
import logoutHandler from "../reducers/logoutHandler";
import redirectHandler from "../reducers/redirectHandler";
import responseStatusHandler from "../reducers/responseStatusHandler";

const store = createStore(responseStatusHandler);
const urlStore = createStore(logoutHandler);
const redirectStore = createStore(redirectHandler);

const coreApi = axios.create({
  baseURL: process.env.REACT_APP_CORE_API,
});

coreApi.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + localStorage.getItem("accessToken") ?? null;
  config.headers["Accept-Language"] = i18n.language;
  return config;
});

coreApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Network failures and CORS-blocked responses have no readable HTTP response.
    if (axios.isCancel(error) || !error?.response) {
      return Promise.reject(error);
    }

    const status = error.response.status;
    const requestUrl = error.config?.url ?? error.response.config?.url;

    if (status === 401 && requestUrl !== "/auth/logout") {
      redirectStore.dispatch(setRedirect(() => true));

      openLogoutNotification();
    } else {
      if (status === 403 || status === 404 || status === 500) {
        store.dispatch(setErrorResponseStatus({ ...error }));
      } else if (status === 422) {
        throwError(error);
      }
    }

    return Promise.reject(error);
  }
);

const catchURL = (myUrl) => {
  urlStore.dispatch(setURL(myUrl));
};

const openLogoutNotification = (myUrl = null) => {
  notification.error({
    message: i18n.t("login.tokenRevokedMessage"),
    description: i18n.t("login.tokenRevokedDescription"),
    duration: null,
  });

  return true;
};

export { coreApi, store, urlStore, catchURL, redirectStore, openLogoutNotification };
